import { Dispatch } from 'redux';
import { api } from '../../service/api';
import { Client, SystemSetting } from '../../types';

import {
  // ACTIONS,
  callWithLoader,
  CLIENTS_ACTIONS,
  handleError,
  // NOTIFICATION_ACTIONS,
  TASK_ACTIONS,
} from './actions';
import showNotificationMessage, {
  notificationTypes,
  showErrorNotification,
  showSuccessNotification,
} from './notificationHelper';

export const getClients = () => (dispatch: Dispatch) => {
  callWithLoader(
    api.getClients().then((res) => {
      dispatch({
        type: CLIENTS_ACTIONS.ALL_CLIENTS,
        payload: res.data,
      });
    }),
    dispatch
  ).catch((err) => {
    handleError(dispatch, err);
  });
};
export const addClient = (client: any) => (dispatch: Dispatch) => {
  let clientId: string;

  callWithLoader(
    api
      .addClient(client)
      .then((res) => {
        dispatch({
          type: CLIENTS_ACTIONS.ADD_CLIENT,
          payload: res.data,
        });

        clientId = res.data.id;

        showSuccessNotification(`Client ${client.ClientName} added.`, dispatch);
      })
      .then((res) => {
        api
          .setupScheduledTasks(clientId)
          .then((res) => {
            const { allTasks, setupDBTask }: any = res.data;

            dispatch({
              type: TASK_ACTIONS.SCHEDULED_TASKS_BY_CLIENT_ID,
              payload: {
                clientId: clientId,
                tasks: allTasks,
              },
            });

            api
              .runScheduledTask(setupDBTask.id, { ClientId: clientId })
              .then((res) => {
                dispatch({
                  type: TASK_ACTIONS.RUN_SCHEDULED_TASK,
                  payload: res.data,
                });
              })
              .catch((err) => {
                showErrorNotification(
                  `Failed to initiate Task
                  Error: ${err.message}`,
                  dispatch
                );
              });
          })
          .catch((err) => {
            showErrorNotification(
              `Failed to schedule tasks for Client ID: ${clientId}
              Error: ${err.message}`,
              dispatch
            );
          });
      }),
    dispatch
  ).catch((err) => {
    console.log(err);
    handleError(dispatch, err);
    showErrorNotification(
      `Failed to add client ${client.ClientName}`,
      dispatch
    );
  });
};
export const updateClient = (client: any) => (dispatch: Dispatch) => {
  callWithLoader(
    api.updateClient(client).then((res) => {
      dispatch({
        type: CLIENTS_ACTIONS.UPDATE_CLIENT,
        payload: res.data,
      });
      showSuccessNotification(
        `Client ${client.data.ClientName} updated`,
        dispatch
      );
    }),
    dispatch
  ).catch((err) => {
    handleError(dispatch, err);
    showErrorNotification(
      `Failed to update ${client.ClientName}
    Error: ${err.message}
    `,
      dispatch
    );
  });
};

export const getClientCredentials = (id: string) => (dispatch: Dispatch) => {
  api.getClientCredentials(id).then((res) => {
    dispatch({
      type: CLIENTS_ACTIONS.CREDENTIALS_BY_CLIENT,
      payload: { clientId: id, credentials: res.data },
    });
  });
};

export const addEntrataCredentials =
  (data, clientId) => (dispatch: Dispatch) => {
    api
      .addEntrataCredentials({ data, clientId })
      .then((res) => {
        dispatch({
          type: CLIENTS_ACTIONS.CREATE_ENTRATA_CREDENTIALS,
          payload: { credentials: res.data, clientId },
        });
        showSuccessNotification(
          `Entrata credentials added for Client with id ${clientId}`,
          dispatch
        );
      })
      .catch((err) => {
        handleError(dispatch, err);
        showErrorNotification(
          `Failed to add entrata credentials for client with id ${clientId}. Error: ${err.message} `,
          dispatch
        );
      });
  };
export const addYardiSippCredentials =
  (data, clientId) => (dispatch: Dispatch) => {
    api
      .addYardiSippCredentials({ ...data, ClientId: clientId })
      .then((res) => {
        dispatch({
          type: CLIENTS_ACTIONS.CREATE_YARDI_SIPP_CREDENTIALS,
          payload: { credentials: res.data, clientId },
        });
        showSuccessNotification(
          `SIPP credentials added for Client with id ${clientId}`,
          dispatch
        );
      })
      .catch((err) => {
        showErrorNotification(
          `Failed to add SIPP credentials for client with id ${clientId}. Error: ${err.message} `,
          dispatch
        );
        handleError(dispatch, err);
      });
  };
export const setEditClient = (client: Client) => (dispatch: Dispatch) =>
  dispatch({
    type: CLIENTS_ACTIONS.SET_EDIT_CLIENT,
    payload: client,
  });
export const setEditUser = (user: Client) => (dispatch: Dispatch) =>
  dispatch({
    type: CLIENTS_ACTIONS.SET_EDIT_USER,
    payload: user,
  });

export const setEditSetting =
  (setting: SystemSetting, clientId: string) => (dispatch: Dispatch) =>
    dispatch({
      type: CLIENTS_ACTIONS.SET_EDIT_SETTING,
      payload: { clientId, setting },
    });

export const clearEditSetting = () => (dispatch: Dispatch) =>
  dispatch({
    type: CLIENTS_ACTIONS.SET_EDIT_SETTING,
  });

export const syncTimeZoneWithClient =
  (clientId) => (dispatch: Dispatch, getState: any) => {
    const state = getState();

    const timeZone = state.clients.clients[clientId]?.TimeZone;
    if (timeZone) {
      callWithLoader(
        api.syncTimeZoneWithClient({ timeZone, clientId }).then((res) => {
          dispatch({
            type: TASK_ACTIONS.SCHEDULED_TASKS_BY_CLIENT_ID,
            payload: { tasks: res.data, clientId },
          });
          showSuccessNotification(
            `All Task synced with ${timeZone} Timezone`,
            dispatch
          );
        }),
        dispatch
      ).catch((err) => {
        handleError(dispatch, err);
        showErrorNotification(
          `Failed to sync timezone
        with err :${err.message}
        `,
          dispatch
        );
      });
    }
  };

//users
export const updateUser = (user) => (dispatch: Dispatch) => {
  callWithLoader(
    api.updateUser(user).then((res) => {
      dispatch({
        type: CLIENTS_ACTIONS.UPDATE_USER,
        payload: res.data,
      });
      showNotificationMessage(
        notificationTypes.success,
        `User <${user.data.EMail}> updated Successfully`,
        dispatch
      );
    }),
    dispatch
  ).catch((err) => {
    console.log(err);
    handleError(dispatch, err);
    showNotificationMessage(
      notificationTypes.error,
      `Failed to updated User <${user.data.EMail}>`,
      dispatch
    );
  });
};

export const addUser = (user) => (dispatch: Dispatch) => {
  callWithLoader(
    api.addUser(user).then((res) => {
      dispatch({
        type: CLIENTS_ACTIONS.ADD_USER,
        payload: res.data,
      });
      showNotificationMessage(
        notificationTypes.success,
        `User <${user.EMail} was added successfully`,
        dispatch
      );
    }),
    dispatch
  ).catch((err) => {
    handleError(dispatch, err);
    showNotificationMessage(
      notificationTypes.error,
      `Failed to add User <${user.EMail}>: ${err.response.data.error}`,
      dispatch
    );
  });
};

export const getUsersByClient = (id: string) => (dispatch: Dispatch) => {
  api
    .getUsersByClients(id)
    .then((res) => {
      dispatch({
        type: CLIENTS_ACTIONS.USERS_BY_CLIENT,
        payload: { clientId: id, users: res.data },
      });
    })
    .catch((err) => {
      handleError(dispatch, err);
    });
};

export const getGroupUsers = (id: string) => (dispatch: Dispatch) => {
  api.getGroupUsers(id).then((res) => {
    dispatch({
      type: CLIENTS_ACTIONS.GROUP_USERS_BY_CLIENT,
      payload: { clientId: id, groupUsers: res.data },
    });
  });
};

export const getSystemSettings = (clientId: string) => (dispatch: Dispatch) => {
  api
    .getSystemSettings(clientId)
    .then((res) => {
      dispatch({
        type: CLIENTS_ACTIONS.SYSTEM_SETTINGS,
        payload: {
          clientId,
          settings: res.data,
        },
      });
    })
    .catch((err) => {
      handleError(dispatch, err);
    });
};

export const updateSetting =
  (setting: SystemSetting, clientId: string) => (dispatch: Dispatch) => {
    return api
      .updateSetting(setting, clientId)
      .then((res) => {
        dispatch({
          type: CLIENTS_ACTIONS.UPDATE_SYSTEM_SETTINGS,
          payload: {
            clientId,
            setting: res.data,
          },
        });

        showNotificationMessage(
          notificationTypes.success,
          'System settings updated',
          dispatch
        );
      })
      .catch((err) => {
        showNotificationMessage(
          notificationTypes.error,
          `${
            err.response.data.error ||
            'Something went wrong, Failed to update settings'
          }`,
          dispatch
        );

        handleError(dispatch, err);
      })
      .finally(() => {
        dispatch({
          type: CLIENTS_ACTIONS.SET_EDIT_SETTING,
        });
      });
  };

export const getClientProperties = (clientId) => (dispatch) => {
  callWithLoader(
    api.getClientProperties(clientId).then((res) => {
      dispatch({
        type: CLIENTS_ACTIONS.CLIENT_PROPERTIES,
        payload: { properties: res.data, clientId },
      });
    }),
    dispatch
  ).catch((err) => {
    handleError(dispatch, err);
  });
};

export const setEditPropertySetting =
  (setting: SystemSetting, clientId: string, propertyId: string) =>
  (dispatch: Dispatch) =>
    dispatch({
      type: CLIENTS_ACTIONS.SET_EDIT_PROPERTY_SETTING,
      payload: { clientId, setting, propertyId },
    });

export const clearEditPropertySetting = () => (dispatch: Dispatch) =>
  dispatch({
    type: CLIENTS_ACTIONS.SET_EDIT_PROPERTY_SETTING,
  });

export const getPropertySettings =
  (clientId: string, propertyId: string) => (dispatch: Dispatch) => {
    callWithLoader(
      api.getPropertySettings(clientId, propertyId).then((res) => {
        dispatch({
          type: CLIENTS_ACTIONS.PROPERTY_SETTINGS,
          payload: {
            clientId,
            propertyId,
            settings: res.data,
          },
        });
      }),
      dispatch
    ).catch((err) => {
      handleError(dispatch, err);
    });
  };

export const updatePropertySetting =
  (setting: SystemSetting, clientId: string, propertyId: string) =>
  (dispatch: Dispatch) => {
    api
      .updatePropertySetting(setting, clientId, propertyId)
      .then((res) => {
        dispatch({
          type: CLIENTS_ACTIONS.UPDATE_PROPERTY_SETTINGS,
          payload: {
            clientId,
            propertyId,
            setting: res.data,
          },
        });
        showNotificationMessage(
          notificationTypes.success,
          'Property setting updated',
          dispatch
        );
      })
      .catch((err) => {
        console.log(err);
        handleError(dispatch, err);
      });
  };

export const resetPropertySettings =
  (clientId: string, propertyId: string) => (dispatch: Dispatch) => {
    callWithLoader(
      api.resetPropertySettings(clientId, propertyId).then((res) => {
        dispatch({
          type: CLIENTS_ACTIONS.RESET_PROPERTY_SETTINGS,
          payload: { clientId, propertyId },
        });
        showNotificationMessage(
          notificationTypes.success,
          'Property settings updated',
          dispatch
        );
      }),
      dispatch
    ).catch((err) => {
      console.log(err);
      handleError(dispatch, err);
    });
  };

export const updateEntrataCredentials =
  (data, clientId) => (dispatch: Dispatch) => {
    api
      .updateEntrataCredentials({ data })
      .then((res) => {
        dispatch({
          type: CLIENTS_ACTIONS.UPDATE_ENTRATA_CREDENTIALS,
          payload: { credentials: res.data, clientId },
        });
        showSuccessNotification(
          `Entrata credentials updated for Client with id ${clientId}`,
          dispatch
        );
      })
      .catch((err) => {
        handleError(dispatch, err);
        showErrorNotification(
          `Failed to update entrata credentials for client with id ${clientId}. Error: ${err.message} `,
          dispatch
        );
      });
  };

export const updateYardiSippCredentials =
  (data, clientId) => (dispatch: Dispatch) => {
    api
      .updateYardiSippCredentials({ data })
      .then((res) => {
        dispatch({
          type: CLIENTS_ACTIONS.UPDATE_YARDI_SIPP_CREDENTIALS,
          payload: { credentials: res.data, clientId },
        });
        showSuccessNotification(
          `Yardi SIPP credentials updated for Client with id ${clientId}`,
          dispatch
        );
      })
      .catch((err) => {
        handleError(dispatch, err);
        showErrorNotification(
          `Failed to update yardi credentials for client with id ${clientId}. Error: ${err.message} `,
          dispatch
        );
      });
  };
export const addSFTPCredentials = (data, clientId) => (dispatch: Dispatch) => {
  api
    .addSFTPCredentials({ data, clientId })
    .then((res) => {
      dispatch({
        type: CLIENTS_ACTIONS.CREATE_SFTP_CREDENTIALS,
        payload: { credentials: res.data, clientId },
      });
      showSuccessNotification(
        `SFTP credentials updated for Client with id ${clientId}`,
        dispatch
      );
    })
    .catch((err) => {
      handleError(dispatch, err);
      showErrorNotification(
        `Failed to update SFTP credentials for client with id ${clientId}. Error: ${err.message} `,
        dispatch
      );
    });
};

export const updateSFTPCredentials =
  (data, clientId) => (dispatch: Dispatch) => {
    api
      .updateSFTPCredentials({ data })
      .then((res) => {
        dispatch({
          type: CLIENTS_ACTIONS.UPDATE_SFTP_CREDENTIALS,
          payload: { credentials: res.data, clientId },
        });
        showSuccessNotification(
          `SFTP credentials updated for Client with id ${clientId}`,
          dispatch
        );
      })
      .catch((err) => {
        handleError(dispatch, err);
        showErrorNotification(
          `Failed to update SFTP credentials for client with id ${clientId}. Error: ${err.message} `,
          dispatch
        );
      });
  };
